<div id="frame-wrapper">
    <iframe src="assets/htmls/fitnessfactory/harlem/webpage.html" width="100%"></iframe>
</div>